// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".small-container[data-v-08540377]{max-width:119.2rem}.max-w-44rem[data-v-08540377],.small-container[data-v-08540377]{margin-left:auto;margin-right:auto}.max-w-44rem[data-v-08540377]{text-align:center;padding-left:1.2rem;padding-right:1.2rem;max-width:44rem}.new-gray[data-v-08540377]{color:#5a5a58}.arrow-right[data-v-08540377]{fill:#333;cursor:pointer;text-align:center;height:1.6rem;width:1.6rem;display:inline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
